import list from './list'
import create from './create'
import show from './show'
import update from './update'

export default {
  namespaced: true,
  modules: {
    list,
    create,
    show,
    update
  }
}
